import apiService from '@Task/service/task-history.service';
import {$handleError } from '@/utils';

export const TASK_HISTORY = { 
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    options: {
      ItemsPerPage:100,
      page:0,
      SortDesc:true
    },
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
 
    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
 
    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    GET({ commit, state },taskId) {
      commit('SET_LOADING', true);
      return apiService
        .get(taskId,state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

  
  },
};
